import request from "@/config/axios";

const mode = 'basedata'; // 对应config里的oDomains的key

// 分页获取消息
export function pageListMessage(data) {
  return request({
    url: '/v1/message/pageListMessage',
    method: 'POST', 
    mode,
    data,
  })
}

export function pageListMessageByType(params) {
  return request({
    url: '/v1/message/getMessageInfoByType',
    method: 'GET', 
    mode,
    params,
  })
}
export function pageListMessageInfo(data) {
  return request({
    url: '/v1/message/pageListMessageByCondition',
    method: 'POST', 
    mode,
    data,
  })
}
